export default {
    listMailTrash: state => state.listMailTrash,
    getSearchFilter: state => state.searchFilter,
    mode: state => state.mode,
}